import { UserPermission } from '../../permission/enum';
export const groupRoutes = [
    {
        path: '',
        name: 'Groups',
        exact: true,
        component: () => import('../views/GroupIndex.vue'),
        meta: {
            breadcrumb: [{ label: 'All Groups' }],
            permissions: [UserPermission.READ_GROUPS],
        },
    },
    {
        path: 'membership',
        name: 'GroupMembership',
        exact: true,
        component: () => import('../views/GroupMembership.vue'),
        meta: {
            breadcrumb: [{ parent: 'Group', label: 'Group Membership' }],
            permissions: [UserPermission.READ_GROUPS, UserPermission.WRITE_GROUPS],
        },
    },
];
